import * as Sentry from "@sentry/react";
import { router } from "src/config/tanstack";

let isInitted = false;

export const initSentry = (): void => {
  if (!__DEV__ && !isInitted) {
    Sentry.init({
      dsn: "https://09bbef0aaf5b401ac84629461abb735d@o252081.ingest.us.sentry.io/4507901638213632",
      integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
      // set at build time, e.g. `SENTRY_RELEASE=$(git rev-parse HEAD) SENTRY_ENV=production yarn build-prod
      environment: __SENTRY_ENVIRONMENT__,
      release: __SENTRY_RELEASE__,
      tracesSampleRate: 0.0, // we dont pay for this
    });
  }
  isInitted = true;
};
